import type { FC, ReactNode } from 'react'

import { ArrowUpRight, ShieldCheck, Star } from 'lucide-react'
import { cn } from '@/lib/utils'
import OpenStatus from '@/components/generals/open-status'

import { BUSINESS } from '@/content/business'

interface HeroTrustProps {
    className?: string
}

// The short trust line under each page opening. The header already shows the
// licence (1280px and up) and the open status (1024px and up), so those two only
// appear here on the screens where the header has no room for them.
const HeroTrust: FC<HeroTrustProps> = ({ className }): ReactNode => (
    <ul className={cn('flex flex-wrap items-center gap-x-6 gap-y-2', className)}>
        <li>
            <a
                href={BUSINESS.googleReviewsUrl}
                target='_blank'
                rel='noopener noreferrer'
                className='group inline-flex items-center gap-2.5 text-base font-bold text-primary no-underline'
            >
                <span className='flex shrink-0 gap-0.5 text-gold' aria-hidden='true'>
                    {Array.from({ length: 5 }).map((_, index) => <Star key={index} className='size-4 fill-current' />)}
                </span>
                <span className='underline decoration-1 underline-offset-4 group-hover:decoration-2'>Read our Google reviews</span>
                <ArrowUpRight className='size-4 shrink-0' aria-hidden='true' />
            </a>
        </li>

        <li className='text-base font-semibold text-[#27455e] lg:hidden'>
            <OpenStatus />
        </li>

        <li className='hidden items-center gap-2 text-base font-semibold text-[#27455e] sm:inline-flex xl:hidden'>
            <ShieldCheck className='size-5 shrink-0 text-primary' aria-hidden='true' />
            Licensed and insured
        </li>
    </ul>
)

export default HeroTrust
